import { atom } from 'jotai';

interface FpsData {
  qrImageUrl: string;
  qrExpiry: string;
  paymentToken: string;
  reference: string;
  redirectUrl: string;
}

export const fpsDataAtom = atom<FpsData | undefined>(undefined);
